import { PAGE_TYPE_HOMEPAGE } from 'shared/consts'
import {
  CSW_PRODUCT_CLICK,
  CSW_SHOW_ALL_CLICK,
  CSW_SHOW_MORE_CLICK,
  HOME_MULTILINE_CSW_ID_CHANGE,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const bindEventsTracking = () => {
  const xSellWidgets = document.querySelectorAll(
    '[data-clientside-api-call~="fetchCrossSell"]'
  )

  xSellWidgets.forEach(xSellWidget => {
    xSellWidget.addEventListener('click', event => {
      const target = <HTMLElement>event.target

      if (target.closest('[data-clientside-hook~="slider__item"]')) {
        trackEvent(CSW_PRODUCT_CLICK)
      }

      if (target.closest('[data-clientside-hook~="slider__header"] a')) {
        trackEvent(CSW_SHOW_ALL_CLICK)
      }

      if (target.closest('[data-clientside-hook~="showMoreButton"]')) {
        trackEvent(CSW_SHOW_MORE_CLICK)
      }
    })
  })
}

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { pageType, experiments } = publicRuntimeConfig?.pageProperties || {}
  const [experiment] = getExperiments(
    [HOME_MULTILINE_CSW_ID_CHANGE],
    experiments
  )

  if (experiment?.isEnabled && pageType === PAGE_TYPE_HOMEPAGE) {
    bindEventsTracking()
  }
}
